
import EmailLogsTable from "./EmailLogsTable";

const EmailLogsTab = () => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">Email Logs</h2>
      <p className="text-muted-foreground">
        Track and monitor email deliveries. You can see the status of each email and retry sending failed emails.
      </p>
      <EmailLogsTable />
    </div>
  );
};

export default EmailLogsTab;
